'use client';

import {
	SimpleGrid, Stack, Text,
} from '@chakra-ui/react';

import { images } from '@/constants/images';
import { CompanyCardFeatured } from '@/modules/job';

const MOCKED = {
	companyName: 'Google LLC',
	image:       images.logo.plusUpRecruit,
	location:    'Bangkok, Thailand',
	salary:      '฿80,000 - ฿120,000',
	title:       'Senior Product Designer',
};

export const PopularCompanyScreen = () => {
	return (
		<Stack gap="lg">
			<Text textAlign="center" textStyle="h1">
				Popular Companies
			</Text>
			<SimpleGrid columns={4} gap="sm">
				{Array.from({ length: 12 }).map((_, index) => (
					<CompanyCardFeatured job={MOCKED} key={`popular-job-${index}`} />
				))}
			</SimpleGrid>
		</Stack>
	);
};
